module.exports = __webpack_public_path__ + "img/arrow-left.47593c52.svg";